class Complementary extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiperPackItemv2 = new Swiper(this.querySelector('.swiper-complementary-2'), {
            slidesPerView: "auto",
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: this.querySelector(' .swiper-next'),
                prevEl: this.querySelector(' .swiper-prev'),
            },


        });
    }
}

customElements.define('complementary-product', Complementary);